"use client";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Link from 'next/link';
import { Search } from 'lucide-react';

// Shared glossary search: live typeahead that links straight to a term page.
// Used on the index, per-letter, and detail pages so search works everywhere.
export default function GlossarySearch({ terms = [], placeholder = 'Search terms...' }) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return [];
    return terms
      .filter((t) => (t.title || '').toLowerCase().includes(q))
      .sort((a, b) => (a.title || '').localeCompare(b.title || ''))
      .slice(0, 8);
  }, [terms, query]);

  // Close the dropdown when clicking outside.
  useEffect(() => {
    const onClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className="search-wrapperr glossary-search-glo" ref={wrapRef}>
      <form className="search-container-glo" onSubmit={(e) => e.preventDefault()}>
        <div className="search-input-wrapper-glo">
          <Search className="search-icon" size={20} />
          <input
            type="text"
            placeholder={placeholder}
            value={query}
            onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
            onFocus={() => setOpen(true)}
          />
        </div>
      </form>
      <button type="button" className="search-btn-glo">Search</button>

      {open && query.trim() && (
        <ul className="search-results-glo">
          {results.length > 0 ? (
            results.map((t) => (
              <li key={t.slug}>
                <Link href={`/glossary/${t.slug}`} onClick={() => setOpen(false)}>
                  {t.title}
                </Link>
              </li>
            ))
          ) : (
            <li className="no-result">No matching terms</li>
          )}
        </ul>
      )}
    </div>
  );
}
